module.exports = __webpack_public_path__ + "img/8.d8cc9efb.svg";